import { render } from "./LayoutNotify.vue?vue&type=template&id=6cc0464a&scoped=true"
import script from "./LayoutNotify.vue?vue&type=script&lang=js"
export * from "./LayoutNotify.vue?vue&type=script&lang=js"

import "./LayoutNotify.vue?vue&type=style&index=0&id=6cc0464a&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc0464a"]])

export default __exports__